import { useContext } from 'react';
import { AuthContext } from '@/context/auth.context';
import useGetApi from 'src/api/useGetApi';

interface KnownDomainsResponse {
  knownDomains: string[];
}

export function useKnownDomains() {
  const { currentUser } = useContext(AuthContext);

  return useGetApi<KnownDomainsResponse>({
    endpoint: 'organization/known-domains',
    options: {
      enabled: !!currentUser?.isAdmin,
    },
  });
}
